import React from 'react';
import {ContextMessage} from '@epic-mw/localization';
import {FormGroup} from './Form.styles';
import {TextFieldSelect, TextFieldSelectItem} from 'epic-ue-components';

interface Properties {
    name: string;
    value: string;
    isValid: boolean;
    fieldId?: string;
    onChange: any;
    onBlur?: any;
    validationClass?: string;
    validationText: string;
    labelText: string;
    messageProp?: string;
    optionValue: string;
    optionLabel: string;
    options: Option[];
    friendlyId?: string;
}

interface Option {
    id: string;
    name: string;
    isDefault?: boolean;
}

const getUniqueOptions = (options, optionValue) => {
    if (!optionValue) {
        console.error('Select.getUniqueOptions() requires an optionValue field');
    }
    const map = {};
    const unique: Option[] = [];
    options.forEach((option) => {
        if (!map[option[optionValue]]) {
            map[option[optionValue]] = true;
            unique.push(option);
        }
    });

    return unique;
};

export const IndustrySelect = (props: Properties): JSX.Element => {
    const {
        name,
        value,
        isValid,
        fieldId,
        onChange,
        onBlur,
        friendlyId,
        validationText,
        labelText,
        optionValue,
        optionLabel,
        messageProp
    } = props;

    const options = props.options || [];
    let labelInnerText;

    if (labelText === null && messageProp) {
        labelInnerText = <ContextMessage code={messageProp} />;
    } else {
        labelInnerText = labelText;
    }

    const uniqueOptions = getUniqueOptions(options, optionValue);

    return (
        <FormGroup className={`form-group`}>
            <TextFieldSelect
                className="IndustrySelect"
                inputProps={{
                    ['data-friendlyid']: friendlyId || ''
                }}
                id={fieldId}
                name={name}
                label={labelInnerText}
                value={value}
                fullWidth
                helperText={isValid ? '' : validationText}
                error={!isValid}
                onChange={onChange}
                onBlur={onBlur}
                SelectProps={{
                    MenuProps: {
                        style: {
                            zIndex: 9999
                        }
                    }
                }}>
                {uniqueOptions
                    ? uniqueOptions.map((option) => {
                          if (!option[optionValue]) {
                              console.warn('Missing key!', option);
                              return null;
                          }
                          return (
                              <TextFieldSelectItem
                                  className="IndustrySelectItem"
                                  key={option[optionValue]}
                                  value={option[optionValue]}
                                  disabled={option.isDefault}>
                                  {option[optionLabel]}
                              </TextFieldSelectItem>
                          );
                      })
                    : null}
            </TextFieldSelect>
        </FormGroup>
    );
};
